// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_p-1";
export var movingGradient = "_p-4";
export var movingGradientBlock = "_p-2";
export var skeleton = "_p-0";
export var skeletonText = "_p-3";